import { Typography } from 'antd'

interface Props {
  provider?: string | null
  methodCode?: string | null
}

export function ProviderMethod({ provider, methodCode }: Props) {
  if (!provider) return <>{'—'}</>
  return (
    <span>
      {provider}
      {methodCode ? (
        <Typography.Text type="secondary"> · {methodCode}</Typography.Text>
      ) : null}
    </span>
  )
}
